export default function UserDirectoryInputDropdown({
    label = '',
    options,
    value, 
    onChange = () => {},
}) {
    return (
        <div>
            {label && (
                <div className="pl-1 pb-1 text-xs text-gray-600">
                    {label}
                </div>
            )}

            <div className="rounded-md border border-gray-300 bg-white focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500">
                <select
                    className="w-full rounded-md bg-white px-3 py-2 border-white border-r-[14px]"
                    value={value ?? ''}
                    onChange={(event) => onChange(event.target.value)}
                >
                    {options.map((option, index) => (
                        <option 
                            key={index} 
                            value={option.value}
                        >
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
}